import { v1 as uuid } from 'uuid';
import { EditableQuestion, StructuredInputField, StructuredInputToggle } from '../../../../../types';

/**
 * Toggle ids are referenced by `default_toggle` and used by clients to remember which
 * unit the patient picked, so they are generated once and never derived from the label —
 * renaming a toggle must not break what points at it.
 */
export const createEmptyToggle = (): StructuredInputToggle => ({
  id: uuid(),
  label: '',
  fields: [],
});

/**
 * A measurement is the reason this feature exists, so a new field starts numeric. The id
 * is left to the author because `answer_template` refers to fields by it.
 */
export const createEmptyField = (): StructuredInputField => ({
  id: '',
  input_type: 'number',
});

/**
 * Clearing default_toggle by setting it to undefined does not work: react-hook-form falls
 * back to the field's original default, so a selector still on screen keeps showing the
 * toggle that was just removed. An empty string is a real value, so it holds, and this
 * sentinel is stripped on the way from form values to a saved question.
 */
export const CLEARED_DEFAULT_TOGGLE = '';

export const withoutClearedDefaultToggle = (question: EditableQuestion): EditableQuestion => {
  if (question.input?.default_toggle !== CLEARED_DEFAULT_TOGGLE) return question;

  const { default_toggle: cleared, ...input } = question.input;

  return { ...question, input };
};
